import React, { useState } from 'react'
import { Button, Icon } from '@arnsbogroup/react-voicearchive'
import { Transition } from '@headlessui/react'
import { useHistory } from 'react-router-dom'
import useCurrentUser from 'hooks/useCurrentUser'

const Actions = ( {supplier, currentUserRoles} ) => {
  const currentUser = useCurrentUser()
  const [showActions, setShowActions] = useState(false)
  const history = useHistory()
  const impersonateSupplier = (supplierContactId) => {
    if(confirm('Are you sure you want to impersonate this user?')) {
      currentUser.impersonate(supplierContactId)
    }
  }

  const destroySupplier = () => {
    if (!confirm('Are you 100% sure you want to delete the supplier? This CAN NOT BE UNDONE by you or by support!')) {
      return
    }

    if (!confirm('Final warning. You are deleting every reference, and any current existing task on the supplier will be invalid. The history of the supplier will be purged and unrecoverable. Are you sure you want to proceed?')) {
      return
    }

    toastr.info('Deleting. Please wait..')
    fetch(`/rest/v2/supplier/${supplier.uid}`, { method: 'DELETE' })
    .then((response) => response.json())
    .then((response) =>{
      if (response.success) {
        toastr.success('All data, info, and history was deleted,', 'Deletion complete', { timeOut: 0, extendedTimeOut: 0 })
        history.push('/dashboard')
      } else {
        toastr.error(response.errors.join(', '), 'Deletion failed')
      }
    })
    .catch((err) => {
      window.alert(err)
    })
  }

  const actions = [
    {
      label: 'Open on website', 
      action: () => window.open(`https://www.voicearchive.com/en/voicefinder/search/${supplier.userid}`, '_blank'),
      className: 'hover:bg-gray-100',
      restrictions: true,
      icon: ['fas', 'external-link']
    },
    {
      label: 'Delete', 
      action: destroySupplier,
      className: 'bg-negative hover:negative-darker text-white',
      restrictions: currentUserRoles.includes('sourcing')
    },
  ]

  return (
    <div className='flex flex-initial my-auto'>
      { supplier.contact &&
        <div className='flex-initial'>
          <Button 
            onClick={() => impersonateSupplier(supplier.contact.uid)} 
            icon={['fas', 'user-friends']}
            disabled={!supplier.contact}
            size='sm'
          >
            Impersonate
          </Button>
        </div>
      }
      <div className='flex-initial my-auto'>
        <div  className="ml-3 relative">
          <div>
            <span className="inline-block relative">
              <Button 
                size="xs"
                variant="inline" 
                onBlur={() => setTimeout(() => setShowActions(false), 200)}
                onClick={() => { setShowActions(!showActions) }}
                aria-haspopup="true" 
                icon={['fas', 'ellipsis-v']} 
                id="supplier-actions"
                className="p-2"
              />
            </span>
          </div>
          <Transition
            show={showActions}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
            className="origin-top-right absolute right-0 mt-2 w-48 rounded-sm shadow-md bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="supplier-actions"
          >
            <ul className="divide-y divide-gray-200 text-gray-700">
              { actions
                  .filter(({ restrictions }) => restrictions)
                  .map(({ label, action, className, icon }) => (
                    <li
                      onClick={action}
                      className={`space-x-2 block px-4 py-2 text-sm hover:bg-gray-100 cursor-pointer ${className}`}
                      key={label}
                    >
                      <span>{ label }</span>

                      { icon &&
                        <Icon icon={icon} />
                      }
                    </li>
                  ))
              }
            </ul>
          </Transition>
        </div>
      </div>
    </div>
  )
}

export default Actions